import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import styles from './contact-list-item.module.scss';

export default class ContactListItemItemCheckbox extends Component {
  handleKeydown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.args.onClick();
    }
  };

  <template>
    <li
      class="{{styles.component}} contact-list-item item-checkbox"
      data-test-contact={{@contact.id}}
      data-test-contact-list-item
      role="button"
      tabindex="-1"
      {{on "click" @onClick}}
      {{on "keydown" this.handleKeydown}}
    >
      {{yield}}
    </li>
  </template>
}
